import {Route, Switch, useLocation} from 'react-router-dom';
import React, {useEffect, useLayoutEffect, useRef} from 'react';
import Error from './pages/404'
import GlobalStyle from "./styles/globalStyle";
import 'react-toastify/dist/ReactToastify.css';
import 'simplebar-react/dist/simplebar.min.css';
import Components from './pages/components';
import Home from './pages/home';
import About from './pages/about';
import Business from './pages/business';
import Media from './pages/media';
import Contact from './pages/contact';
import Career from './pages/career';
import Project from './pages/projects';
import ProjectDetail from './pages/projects/single';
import MediaDetail from './pages/media/single';
import MainMenu from "./components/MainMenu";
import {ToastContainer} from "react-toastify";
import Footer from "./components/Footer";
import Responsibility from "./pages/responsibility";
import Test from "./pages/test";
import TalentDetail from "./components/Projects/TalentDetail";
import {Parallax, ParallaxImg, ParallaxItem} from "./animation/parallax";
import {ImageReveal} from "./animation/imageReveal";
import {SplitUp} from "./animation/TextAnimation";
import {ScrollSmoother} from "gsap/ScrollSmoother";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {gsap, TimelineLite} from "gsap";
import {useDispatch, useSelector} from "react-redux";
import {loading} from "./api/redux/global";
import {DrawSVGPlugin} from "gsap/dist/DrawSVGPlugin";
import PageTransition from "./animation/PageTransition";
import PageTransitionV2 from "./animation/PageTransitionV2";


function App() {
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother, DrawSVGPlugin);
    const location = useLocation();
    let MainStore = useSelector(state => state)
    let store = useSelector(state => state.home)
    const dispatch = useDispatch()
    const el = useRef();

    // parallax
    Parallax()
    ParallaxImg()
    ParallaxItem()
    // image reveal
    ImageReveal()
    // text test
    SplitUp()
    // page transition
    PageTransitionV2()

    // smooth scroll
    let smoother;
    useLayoutEffect(() => {
        smoother = ScrollSmoother.create({
            smooth: 2, // how long (in seconds) it takes to "catch up" to the native scroll position
            effects: true, // looks for data-speed and data-lag attributes on elements
            // speed: 2,
        });
        ScrollTrigger.refresh();

        if (location.hash) {
            setTimeout(() => {
                smoother.scrollTo(location.hash, 3)
            }, 300)
        }
    }, [location, location.pathname, location.hash])


    return (
        <React.Fragment>
            <ToastContainer position="top-right" autoClose={4000} closeOnClick hideProgressBar={true}/>

            <GlobalStyle/>
            <MainMenu/>

            {/*page transition */}
            <div className="page-loader">
                <img src={'/images/static/ucc-logo-white.svg'}/>
            </div>


            <div className="App" ref={el} id="smooth-wrapper">
                <div id="smooth-content">
                    <Switch>
                        <Route exact path="/"><Home/></Route>
                        <Route exact path="/components" component={Components}/>
                        <Route exact path="/about-infratech"><About smoother={smoother}/></Route>
                        <Route exact path="/business-domains" component={Business}/>
                        <Route exact path="/media-center" component={Media}/>
                        <Route exact path={`/media-center/:slug`} component={MediaDetail}/>
                        <Route exact path={`/projects`} component={Project}/>
                        <Route exact path={`/project/:slug`} component={ProjectDetail}/>
                        <Route exact path={`/projects/talenthunt`} component={TalentDetail}/>
                        <Route exact path={`/contact`} component={Contact}/>
                        <Route exact path={`/career`} component={Career}/>
                        <Route exact path={`/social-responsibility-and-esg`} component={Responsibility}/>
                        <Route exact path={`/animation-test`} component={Test}/>
                        <Route component={Error}/>
                    </Switch>
                    <Footer/>
                </div>
            </div>
        </React.Fragment>
    );
}

export default App;
